import { render, staticRenderFns } from "./PersonAssociate.vue?vue&type=template&id=76aa29ca"
import script from "./PersonAssociate.vue?vue&type=script&lang=js"
export * from "./PersonAssociate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports